import React from 'react';
import './style.css';
import Input from '../../../common/InputField';

function TicketSubject({ subject, setSubject }) {
  return (
         <Input
          value={subject}
          onChange={(e) =>  setSubject(e.target.value)}
          title="Ticket subject"
          type="text"
          placeholder="Subject"
        />
  );
}

export default TicketSubject;
